import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faThermometerHalf } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NumberBox } from 'devextreme-react/number-box'
import React, { createRef, FC, Fragment } from 'react'
import { TrailerTemperature } from 'services/types'

type Props = {
    temperature: TrailerTemperature,
    valueChanged: (setValue: number | null, actualValue: number | null) => void,
}

export const TempIntegrityDetail: FC<Props> = ({ temperature, valueChanged }) => {

    const setValueRef = createRef<NumberBox>()
    const actualValueRef = createRef<NumberBox>()

    const getNewValue = (numberBox: any, e: any) => {
        let parsedValue = numberBox._parsedValue
        if (e.keyCode === 229 /*negative on device keyboard*/) {
            parsedValue = -1 * parsedValue
        }
        parsedValue = (parsedValue == 0 && numberBox._lastKeyName == "backspace") ? null : parsedValue
        return parsedValue
    }

    const setValueHandleKeyUp = (e: any) => {
        let numberBox = setValueRef && setValueRef.current && setValueRef.current.instance
        let value = getNewValue(numberBox, e)
        valueChanged(value, temperature.actualValue)
    }

    const actualValueHandleKeyUp = (e: any) => {
        let numberBox = actualValueRef && actualValueRef.current && actualValueRef.current.instance
        let value = getNewValue(numberBox, e)
        valueChanged(temperature.setValue, value)
    }

    return (
        <Fragment>
            <div className={'temp-row'}>
                <div className={"temp-fa-icon"}><FontAwesomeIcon icon={faThermometerHalf as IconProp} size='2x' color='#F2994A' /></div>
                <div className={'temp-text'}>Set</div>
                <div className={'temp-value'}>
                    <NumberBox
                        min={-20}
                        max={120}
                        format="#0 &#8457;"
                        ref={setValueRef}
                        onKeyUp={(e) => setValueHandleKeyUp(e.event)}
                        value={temperature.setValue ?? undefined}
                        onValueChanged={(e) => valueChanged(e.value, temperature.actualValue)}
                    />
                </div>
            </div>
            <div className={'temp-row'}>
                <div className={"temp-fa-icon"}><FontAwesomeIcon icon={faThermometerHalf as IconProp} size='2x' color='#F2994A' /></div>
                <div className={'temp-text'}>Actual</div>
                <div className={'temp-value'}>
                    <NumberBox
                        min={-20}
                        max={120}
                        format="#0 &#8457;"
                        ref={actualValueRef}
                        onKeyUp={(e) => actualValueHandleKeyUp(e.event)}
                        value={temperature.actualValue ?? undefined}
                        onValueChanged={(e) => valueChanged(temperature.setValue, e.value)}
                    />
                </div>
            </div>
        </Fragment>
    )
}